module.exports = __webpack_public_path__ + "b34c156b7d199cffe9a8bc8ea8f911f1.mp4";